var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{style:([_vm.style]),attrs:{"fit":_vm.fit,"initial-index":_vm.initialIndex,"preview-src-list":_vm.previewSrcListComputed,"src":_vm.src?_vm.loadImg(_vm.src,_vm.replacePx(_vm.width),_vm.replacePx(_vm.height),_vm.text,_vm.size):_vm.defaultSrc,"lazy":_vm.lazy,"data-index":_vm.dataIndex}})
}
var staticRenderFns = []

export { render, staticRenderFns }